import { setOffsetsOnScrollAT } from "./SetOffsetsOnScrollModel";
import { IScrollContainerMeasure } from "../../scroll/perfectScrollModel";

export const setOffsetsOnScrollAction = (
    scrollTop: number,
    scrollLeft: number
) => ({
    type: setOffsetsOnScrollAT.update,
    scrollTop,
    scrollLeft,
});

export const setDimensionsAction = (measure: IScrollContainerMeasure) => ({
    type: setOffsetsOnScrollAT.setUp,
    ...measure,
});
